import { userPaths } from 'routes/constants/userPaths';
import { isUserAuthenticated } from 'routes/guards/session';

import { Navigate, Outlet, useLocation } from 'react-router-dom';

/**
 * Public end-user routes.
 * Credential entry (email / phone / OTP) stays reachable while authenticated so a
 * new user can replace the previous session. Other public routes still redirect.
 */
const UserPublicRoute = () => {
  const { pathname } = useLocation();
  const isCredentialEntryRoute =
    pathname === userPaths.signIn ||
    pathname === userPaths.signInPhone ||
    pathname === userPaths.signInOtp;

  if (isUserAuthenticated() && !isCredentialEntryRoute) {
    return <Navigate to={userPaths.dashboard} replace />;
  }

  return <Outlet />;
};

export default UserPublicRoute;
